import React, { useState, useRef } from 'react'
import emailjs from '@emailjs/browser'

function Contact() {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    emailjs
      .sendForm('service_ekako97', 'template_y40pszg', form.current, {
        publicKey: 't3rPYjEZLB2J1W3zV',
      })
      .then(
        () => {
          setIsSubmitting(false);
          setSubmitStatus('success');
          form.current.reset();
          setTimeout(() => setSubmitStatus(''), 5000);
        },
        (error) => {
          setIsSubmitting(false);
          setSubmitStatus('error');
          console.log('FAILED...', error.text);
          setTimeout(() => setSubmitStatus(''), 5000);
        },
      );
  };

   return (
    <main id="primary" className="site-main">
      {/* start: Breadcrumb Section */}
      <section className="tj-page-header section-gap-x" data-bg-image="assets/images/bg/pheader-bg.webp">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="tj-page-header-content text-center">
                <h1 className="tj-page-title">Contact Us</h1>
                <div className="tj-page-link">
                  <span><i className="fa-solid fa-home"></i></span>
                  <span>
                    <a href="/">Home</a>
                  </span>
                  <span><i className="fa-solid fa-arrow-right"></i></span>
                  <span>
                    <span>Contact Us</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-header-overlay" data-bg-image="assets/images/shape/pheader-overlay.png"></div>
      </section>
      {/* end: Breadcrumb Section */}

      {/* start: Contact Top Section */}
      <div className="tj-contact-area section-gap" >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="sec-heading text-center">
                <span className="sub-title wow fadeInUp" data-wow-delay=".1s"><i className="fa-solid fa-box"></i>Contact info</span>
                <h2 className="sec-title title-anim"><span>Reach</span> Out to Us</h2>
              </div>
            </div>
          </div>
          <div className="row row-gap-4" style={{alignItems:'center'}}>
            <div className="col-xl-4 col-lg-6 col-sm-6">
              <div className="contact-item style-2 wow fadeInUp" data-wow-delay=".3s">
                <div className="contact-icon">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <h3 className="contact-title">Our Location</h3>
                Shed No.31, Raghav Industrial Park, B/h. Krish Arcade, Nr. Adani Circle, S.P. Ring Road, Ramol, Ahmedabad - 382449 (Gujarat)
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-sm-6">
              <div className="contact-item style-2 wow fadeInUp" data-wow-delay=".5s">
                <div className="contact-icon">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <h3 className="contact-title">Email us</h3>
                <ul className="contact-list">
                  {/* <li><a href="mailto:support@bexon.com">support@bexon.com</a></li> */}
                  <li><a href="mailto:sdpharma795@gmail.com">sdpharma795@gmail.com</a></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-sm-6">
              <div className="contact-item style-2 wow fadeInUp" data-wow-delay=".7s">
                <div className="contact-icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <h3 className="contact-title">Call us</h3>
                <ul className="contact-list">
                  <li><a href="tel:9537503030">+91 95375 03030</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end: Contact Top Section */}

      {/* start: Contact Section */}
      <section className="tj-contact-section-2 section-bottom-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="contact-form wow fadeInUp" data-wow-delay=".1s">
                <h3 className="title">Feel Free to Get in Touch or Visit our Location.</h3>
                {submitStatus === 'success' && (
                  <div style={{ padding: '15px', marginBottom: '20px', backgroundColor: '#d4edda', color: '#155724', border: '1px solid #c3e6cb', borderRadius: '5px' }}>
                    Thank you! Your message has been sent successfully.
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div style={{ padding: '15px', marginBottom: '20px', backgroundColor: '#f8d7da', color: '#721c24', border: '1px solid #f5c6cb', borderRadius: '5px' }}>
                    Sorry, there was an error sending your message. Please try again.
                  </div>
                )}
                <form ref={form} onSubmit={sendEmail} id="contact-form">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-input">
                        <input type="text" name="user_name" required />
                        <label className="cf-label">Full Name <span>*</span></label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-input">
                        <input type="email" name="user_email" required />
                        <label className="cf-label">Email Address <span>*</span></label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-input">
                        <input type="tel" name="user_phone" required />
                        <label className="cf-label">Phone number <span>*</span></label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-input">
                        <div className="tj-nice-select-box">
                          <div className="tj-select">
                            <select name="product_interest" required>
                              <option value="">Select Product Interest</option>
                              <option value="Tablet Press Machine">Tablet Press Machine</option>
                              <option value="Roll Compactor">Roll Compactor</option>
                              <option value="Tablet Coating Machine">Tablet Coating Machine</option>
                              <option value="Rapid Mixer Granulator">Rapid Mixer Granulator</option>
                              <option value="Fluid Bed Dryer">Fluid Bed Dryer</option>
                              <option value="Complete Production Line">Complete Production Line</option>
                              <option value="Spare Parts & Service">Spare Parts & Service</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-input message-input">
                        <textarea name="message" id="message" required></textarea>
                        <label className="cf-label">Type message <span>*</span></label>
                      </div>
                    </div>
                    <div className="submit-btn">
                      <button className="tj-primary-btn" type="submit" disabled={isSubmitting}>
                        <span className="btn-text">
                          <span>{isSubmitting ? 'Sending...' : 'Submit Now'}</span>
                        </span>
                        <span className="btn-icon">
                          <i className={`fa-solid ${isSubmitting ? 'fa-spinner fa-spin' : 'fa-arrow-right'}`}></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="map-area wow fadeInUp" data-wow-delay=".3s">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.2684614215777!2d72.65756177438604!3d22.977153479205587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e89c672f0aa3f%3A0x4f031fe865bc24c3!2sSarthi%20parisar!5e0!3m2!1sen!2sin!4v1762663824513!5m2!1sen!2sin" width="600" height="450" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* end: Contact Section */}
    </main>
  );
}

export default Contact
